import { Box, SimpleGrid, VStack } from '@chakra-ui/react';
import { useEffect, useState } from 'react';
import { PROJECT_TYPE, PROJECTS } from '../../data/projects';
import { Header } from './header';
import { ProjectCard } from './projectCard';
import { ProjectsHeader } from './projectsHeader';

const ProjectsPage = () => {
  const [type, setType] = useState('All');
  const [filteredProject, setFilteredProject] = useState(PROJECTS);
  useEffect(() => {
    if (type === 'All') {
      setFilteredProject(PROJECTS);
    } else {
      const currentType = type === 'Mobile Apps' ? [PROJECT_TYPE.IOS, PROJECT_TYPE.ANDROID] : [PROJECT_TYPE.WEB];
      const filtered = PROJECTS.filter(project => project.types.some(t => currentType.includes(t)));
      setFilteredProject(filtered);
    }
  }, [type]);

  return (
    <VStack spacing={6} width={'100%'} justifyContent="center" alignItems="center">
      <Box width={'100%'} h={400} bg={'red'}>
        <Header />
      </Box>
      <Box width={'80%'} h={'70%'}>
        <ProjectsHeader type={type} onTypeChange={setType} />
        <SimpleGrid columns={{ base: 1, sm: 1, md: 2, lg: 3, xl: 3 }} spacing={3}>
          {filteredProject.map(project => (
            <ProjectCard key={project.id} project={project} />
          ))}
        </SimpleGrid>
      </Box>
    </VStack>
  );
};

export default ProjectsPage;
